function TableTagSVG({ text }) {
  return (
    <div className="d-flex">
      <svg
        height="22"
        viewBox="0 0 16 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M15.0659 0L29.9999 14.934L14.934 30L3.53548 18.6015C1.58286 16.6489 1.58285 13.4831 3.53547 11.5304L15.0659 0Z"
          fill="#D9D9D9"
        />
        <circle cx="9" cy="15.0001" r="2" fill="white" />
      </svg>
      <div className="clientTag">
        <span>{text}</span>
      </div>
    </div>
  );
}

export default TableTagSVG;
